import { render, staticRenderFns } from "./resource-detail.vue?vue&type=template&id=bc8b0eea"
import script from "./resource-detail.vue?vue&type=script&lang=js"
export * from "./resource-detail.vue?vue&type=script&lang=js"
import style0 from "./resource-detail.vue?vue&type=style&index=0&id=bc8b0eea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports